import { createEntryPoint } from '#packages/apilib';
import { CompPointersScope } from './compPointersScope';
import { CompPointersApi } from './compPointersApi';
import { CompPointersApiKey } from './publicApiKey';

export const CompPointersEntryPoint = createEntryPoint({
  name: 'CompPointers',
  Scope: CompPointersScope,
  publicApi({ contributeApi }) {
    contributeApi(CompPointersApiKey, CompPointersApi);
  },
});

export { CompPointersApiKey };
export type { CompPointersApi };
export type { CompPointer } from './compPointersTypes';
